// 빌드 시점에 vue.config.js 가 process.env.VUE_APP_BUILD_VERSION 에 git SHA 를 주입한다.
// 같은 SHA 가 dist/version.json 으로도 emit 되며, 프런트엔드는 주기적으로 /version.json
// 을 fetch 해 자기 자신의 BUILD_VERSION 과 비교한다. 다르면 사용자에게 알림.
//
// 캐시 무력화: Apache vhost 에서 /version.json 은 no-cache 로 헤더를 박았고,
// fetch 단에서도 cache:'no-store' 로 한 번 더 안전망.

const CURRENT_VERSION = (process.env.VUE_APP_BUILD_VERSION || '').trim();
const POLL_INTERVAL_MS = 5 * 60 * 1000;
const INITIAL_DELAY_MS = 30 * 1000;

let pollHandle = null;
let initialHandle = null;
let triggered = false;

async function fetchRemoteVersion() {
	try {
		const res = await fetch('/version.json', {
			cache: 'no-store',
			headers: { 'Cache-Control': 'no-cache', Pragma: 'no-cache' },
		});
		if (!res.ok) return null;
		const data = await res.json();
		return data && typeof data.version === 'string' ? data.version.trim() : null;
	} catch {
		return null;
	}
}

export function getCurrentVersion() {
	return CURRENT_VERSION;
}

// 새 버전 감지 시 onUpdate(payload) 가 한 번만 호출된다.
// dev 빌드 (BUILD_VERSION 미주입) 또는 'unknown' 인 경우 폴링하지 않는다 — 매 hot-reload
// 마다 SHA 가 바뀌면 false-positive 가 너무 많아진다.
export function startVersionPoll(onUpdate) {
	if (pollHandle || initialHandle || triggered) return;
	if (!CURRENT_VERSION || CURRENT_VERSION === 'dev' || CURRENT_VERSION === 'unknown') return;

	const check = async () => {
		if (triggered) return;
		const remote = await fetchRemoteVersion();
		if (remote && remote !== CURRENT_VERSION) {
			triggered = true;
			stopVersionPoll();
			try {
				onUpdate({ current: CURRENT_VERSION, remote });
			} catch (e) {
				// 호출자 측 예외가 폴링 정지에 영향 주지 않게 swallow.
				// eslint-disable-next-line no-console
				console.error('[buildVersion] onUpdate threw:', e);
			}
		}
	};

	// 부팅 직후 트래픽 피크 회피를 위해 initial 체크는 30초 지연.
	initialHandle = setTimeout(() => {
		initialHandle = null;
		check();
	}, INITIAL_DELAY_MS);
	pollHandle = setInterval(check, POLL_INTERVAL_MS);
}

export function stopVersionPoll() {
	if (pollHandle) {
		clearInterval(pollHandle);
		pollHandle = null;
	}
	if (initialHandle) {
		clearTimeout(initialHandle);
		initialHandle = null;
	}
}
